import styled from '@emotion/styled'

export const TableMessage = styled.p`
  font-size: 0.75em;
  color: #8b8a90;
  font-family: 'proxima-nova', sans-serif;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
  font-weight: 700;
  margin: 1em 0;
`

export const MessageHighlight = styled.span`
  color: #345dd4;
  font-weight: bold;
`
